var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeDetailInfoSiteOne',{scopedSlots:_vm._u([{key:"header-one",fn:function(){return [_c('h1',{staticStyle:{"max-width":"800px"}},[_vm._v(" Share your Sequences with your company")])]},proxy:true},{key:"text-one",fn:function(){return [_c('p',{style:(`max-width: 700px;
      font-style: normal;
      font-size: 20px;

      ${_vm.$vuetify.breakpoint.smAndDown ? 'padding: 50px 20px 20px 20px' : 'padding: 50px 20px 30px 20px;'}`)},[_vm._v(" A company needs standards. In the TAKT.app we already deliver the standards. WORK.packages and WORK.sequences are ready to share with my company in our PRO.account. ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }